import { useTranslation } from 'react-i18next';
import DetailsWrapper from '../../../components/Details/DetailsWrapper';
import { IconButton, LinearProgress, Paper, Stack, Tooltip, Typography } from '@mui/material';
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import LaunchIcon from '@mui/icons-material/Launch';
import { useNavigate } from 'react-router-dom';
import { Box } from '@mui/system';
import DetailsLinkedIcon from '../../../components/Details/DetailsLinkedIcon';

interface IDetailsSulloges{
    documents:any[];
    sullogesInfo?: any[];
    isLoading?: boolean;
    foreas?: any[];
}

const DetailsSulloges = (props: IDetailsSulloges) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { documents, sullogesInfo, isLoading, foreas } = props;
             
  const columns: GridColDef[] = [
    {
      field: 'title',
      headerName: t('Τίτλος Τεκμηρίου') || undefined,
      minWidth: 350,
      sortable: false,
    },
    {
      field: 'type',
      headerName: t('Τύπος Τεκμηρίου') || undefined,
      minWidth: 250,
      sortable: false,
    },
    {
      field: 'relateCollection',
      headerName: t('Τίτλος Συλλογής') || undefined,
      minWidth: 315,
      sortable: false,

    },
    {
      field: 'relateOrganisation',
      headerName: t('Τίτλος Φορέα') || undefined,
      minWidth: 450,
      sortable: false,
    },
    {
      field: 'info',
      headerName: t('Λεπτομέρειες') || undefined,
      minWidth: 130,
      sortable: false,
      renderCell: (params) => 
        <Tooltip PopperProps={{
          disablePortal: true
        }}
        title={t('Προβολή')}>
          <IconButton onClick={() => navigate(`${params.row.url}`)}>
            <LaunchIcon color='primary'/></IconButton>
        </Tooltip>
    },];

  return (
    <>
      {sullogesInfo && <DetailsWrapper
        title={t('Πληροφορίες Συλλογής')}
        detailsProps={{
          rows: sullogesInfo,
          removeLines: true
        }}
      />}
      <DetailsLinkedIcon title={t('Φορέας Συλλογής')}
        detailsList={foreas}
      />
      <Box mt={5} minWidth={350}>
        <Paper variant='outlined' 
          sx={{ height: 'fit-content', borderRadius: 2, boxShadow: 0, backgroundColor: 'transparent'}}>
          <Typography m={2} variant='h3'>{t('Τεκμήρια Συλλογής')}</Typography>
          <Box m={1} >
            <DataGrid
              loading={isLoading}
              componentsProps={{
                pagination: {
                  SelectProps: {
                    MenuProps: {
                      disablePortal: true,
                    }
                  }
                }
              }}
              disableColumnMenu
              disableSelectionOnClick
              autoHeight
              sortingMode='server'
              columns={columns}
              rows={documents}
              components={{
                LoadingOverlay: LinearProgress,
                NoRowsOverlay: () => (
                  <Stack height='100%' alignItems='center'
                    justifyContent='center'>
                    {t('Δεν υπάρχουν εγγραφές')}
                  </Stack>
                )
              }}
              sx={{
                '& .MuiDataGrid-columnHeaders': {
                  backgroundColor: '#F2F2F2',
                  fontSize: 16
                },
                '& .MuiDataGrid-columnHeaderTitle': {
                  textOverflow: 'clip',
                  whiteSpace: 'break-spaces',
                  lineHeight: 1
                },
                '& .MuiDataGrid-cell': {
                  textOverflow: 'clip',
                  whiteSpace: 'break-spaces',
                  lineHeight: 1
                }}}
            />       
          </Box> 
        </Paper>    
      </Box>
    </>
  );
};

export default DetailsSulloges;